import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { useConsent } from '@/contexts/ConsentContext';

/**
 * Fires a GA4 page_view on every client-side navigation.
 * Renders nothing — mount inside <BrowserRouter> but outside route definitions.
 */
export function RouteTracker() {
  const location = useLocation();
  const { consent } = useConsent();

  useEffect(() => {
    if (consent?.analytics) {
      ReactGA.send({
        hitType: 'pageview',
        page: location.pathname + location.search,
      });
    }
  }, [location, consent?.analytics]);

  return null;
}
